import React, {Component, ReactNode} from 'react'
import styled from 'styled-components'
import { Paper } from '@mui/material';

interface Props {
    children: ReactNode,
    content: ReactNode,
    anchor?: 'top-center' | 'top-end',
}

interface ContentPosition {
    top?: number,
    left?: number,
    right?: number,
    bottom?: number,
}

interface State {
    openTimerId: number | null,
    isMount: boolean,
    isOpen: boolean,
    contentPosition: ContentPosition,
}

class HoverPopupArea extends Component<Props, State> {
    constructor(props: Props) {
        super(props)
        this.state = {
            openTimerId: null,
            isMount: false,
            isOpen: false,
            contentPosition: {
                top: 0,
                left: 0,
            },
        }
    }

    handleMouseEnter = (event: React.MouseEvent<HTMLElement>) => {
        const target = event.currentTarget
        const {clientHeight, clientWidth} = target
        const {anchor} = this.props
        const openTimerId = window.setTimeout(
            () => {
                const content = target.lastElementChild
                if(!content){
                    // ContentWrapperがないことになるので論理矛盾
                    return
                }
                const contentWidth = content.clientWidth

                let contentPosition: ContentPosition = {
                    top: 0,
                    left: 0,
                }

                switch (anchor) {
                    case 'top-center':
                        contentPosition = {
                            bottom: clientHeight,
                            left: (clientWidth - contentWidth) / 2,
                        }
                        break
                    case 'top-end':
                        contentPosition = {
                            bottom: clientHeight,
                            right: 0,
                        }
                }

                this.setState({
                    openTimerId: null,
                    isOpen: true,
                    contentPosition: contentPosition,
                })
            },
            500,
        )
        this.setState({
            openTimerId: openTimerId,
            isMount: true,
            contentPosition: {
                bottom: 0,
                left: 0,
            },
        })
    }

    handleMouseLeave = () => {
        const {openTimerId} = this.state
        if (openTimerId !== null) {
            window.clearTimeout(openTimerId)
        }
        this.setState({
            openTimerId: null,
            isMount: false,
            isOpen: false,
        })
    }

    render(): ReactNode {
        const {isMount, isOpen, contentPosition} = this.state
        const {children, content} = this.props

        return <TriggerArea
            onMouseEnter={this.handleMouseEnter}
            onMouseLeave={this.handleMouseLeave}
        >
            {children}
            {isMount &&
            <ContentWrapper
                elevation={4}
                $isOpen={isOpen}
                style={contentPosition}
            >
                {content}
            </ContentWrapper>
            }
        </TriggerArea>
    }
}

export default HoverPopupArea

const TriggerArea = styled.div`
  position: relative;
`
const ContentWrapper = styled(Paper)<{ $isOpen: boolean }>`
  position: absolute;
  z-index: 1000;
  transition: opacity 0.2s;
  ${props => props.$isOpen ? `
    visibility: visible;
    opacity: 1;
  ` : `
    visibility: hidden;
    opacity: 0;
  `}
`
